<template>
  <div>
    <a href="#" @click="fullRTF(slg + 'wrap')" class="top-right-align"
      >Full Editor</a
    >
    <div :id="slg + 'wrap'">
      <div class="top-menu ftf w-clearfix">
        <h4 data="main-title" class="item-head top">{{ $parent.info.name }}</h4>
        <p class="date">{{ fname }}</p>
        <div data="status" class="top"></div>
        <div>
          <a
            @click="regRTF(slg + 'wrap')"
            data-closefs="contentbglrtf"
            href="#"
            class="button black w-button"
            >Close</a
          >
        </div>
      </div>
      <Editor
        v-if="initObj"
        v-model="content"
        api-key="0osf650psj1649yurge59pgmpyar9h76bwjlxcrgrrnayxmu"
        :init="initObj"
      />
    </div>
  </div>
</template>

<script>
//import { Script } from "vm";
import Editor from "@tinymce/tinymce-vue";

export default {
  name: "RichText",
  props: ["slg", "fname", "value"],
  data() {
    return {
      content: this.value,
      initObj: false,
    };
  },
  mounted() {
    console.log();
  },
  components: { Editor },
  methods: {
    fullRTF(id) {
      $("#" + id).addClass("full");
    },
    regRTF(id) {
      $("#" + id).removeClass("full");
    },
  },
  async created() {
    if (this.$parent.$parent.activeSite.rtf && !window.rtf) {
      $.getScript(this.$parent.$parent.activeSite.rtf, () => {
        this.initObj = window.rtf;
      });
    } else {
      this.initObj = window.rtf || {
        file_picker_callback(callback, value, meta) {
          if (meta.filetype == "image") {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.click();
            input.onchange = () => {
              console.log("input changed");
              var file = input.files[0];
              var uploader = window.fs.ref(`rtf/${file.name}`).put(file);
              console.log("state changed");
              uploader.on(
                "state_changed",
                () => {
                  console.log("state changed");
                },
                (err) => {
                  alert("error", err);
                },
                () => {
                  uploader.snapshot.ref.getDownloadURL().then((url) => {
                    callback(url);
                  });
                }
              );
            };
          }
        },
        menubar: false,
        toolbar: [
          "image link ltr rtl table hr code h1 h2 h3 h4 h5 blockquote autolink media numList fontsizeselect",
        ],
        max_height: 500,
        plugins: [
          "lists",
          "advlist",
          "directionality",
          "advlist",
          "autolink",
          "lists",
          "link",
          "image",
          "charmap",
          "preview",
          "anchor",
          "searchreplace",
          "visualblocks",
          "advcode",
          "code",
          "media",
          "table",
          "paste",
          "imagetools",
          "hr",
          "autoresize",
        ],
      };
    }
  },
  watch: {
    content() {
      this.$emit("input", this.content);
    },
  },
};
</script>

<style>
.tox-notifications-container {
  display: none !important;
}
/* .tox.tox-tinymce {
  height: 380px !important;
} */
.top-menu.ftf.w-clearfix {
  display: none;
}
.full .top-menu.ftf.w-clearfix {
  display: flex;
  height: 50px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  right: 0;
}
.full .tox.tox-tinymce {
  position: fixed;
  top: 50px;
  bottom: 0;
  z-index: 999;
  right: 0;
  margin-bottom: 0;
  left: 0;
  height: 100% !important;
}
.full .tox-edit-area {
  background-color: #f4f4f4;
}
.full iframe.tox-edit-area__iframe {
  max-width: 800px;
  margin-top: 8px;
  background: white;
  margin-left: calc(50vw - 400px);
  margin-right: calc(50vw - 400px);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
  padding-bottom: 40px;
}
</style>